var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardGenerator = function SvgIconDashboardGenerator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "#2BB673"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFD",
    d: "M34.665 12.001a2.667 2.667 0 0 1 2.666 2.667v18.667A2.667 2.667 0 0 1 34.665 36H13.33a2.667 2.667 0 0 1-2.666-2.666v-8a1.333 1.333 0 0 1 2.666 0v2.8l6.66-6.659a1.667 1.667 0 0 1 2.358 0l5.42 5.421 1.65-1.65a1.667 1.667 0 0 1 2.358 0l2.888 2.889V14.668H23.998a1.333 1.333 0 1 1 0-2.667zm-20-1.333a1.33 1.33 0 0 1 1.197.747l.064.156.173.504a4 4 0 0 0 2.246 2.4l.246.093.504.172a1.333 1.333 0 0 1 .156 2.459l-.156.064-.504.173a4 4 0 0 0-2.4 2.245l-.093.247-.172.504a1.334 1.334 0 0 1-2.459.156l-.064-.156-.173-.504a4 4 0 0 0-2.245-2.4l-.247-.093-.504-.172a1.333 1.333 0 0 1-.156-2.459l.156-.064.504-.173a4 4 0 0 0 2.4-2.246l.093-.246.172-.504a1.33 1.33 0 0 1 1.262-.903m14 6.667a2 2 0 1 1 0 3.999 2 2 0 0 1 0-4"
  })));
};
export default SvgIconDashboardGenerator;